var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "site-root",
      class: { "site-root--fixed-bg": _vm.hasFixedBackground },
      style: _vm.rootStyle,
    },
    [
      _c(
        "div",
        { staticClass: "site-page", style: _vm.pageStyle },
        [
          _vm.loading
            ? _c("div", { staticClass: "site-loading" }, [
                _c("i", { staticClass: "fa fa-spinner fa-spin fa-2x" }),
              ])
            : _vm.passwordState.required
            ? _c("div", { staticClass: "site-password-gate" }, [
                _c("div", { staticClass: "site-password-gate__box" }, [
                  _c("i", {
                    staticClass: "fa fa-lock site-password-gate__icon",
                  }),
                  _vm._v(" "),
                  _c("h2", { staticClass: "site-password-gate__title" }, [
                    _vm._v(
                      _vm._s(_vm.passwordState.pageTitle || "Protected Page")
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "site-password-gate__desc" }, [
                    _vm._v(
                      "This page is password protected. Please enter the password to view it."
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "form",
                    {
                      staticClass: "site-password-gate__form",
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.submitPassword.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.passwordState.input,
                            expression: "passwordState.input",
                          },
                        ],
                        ref: "passwordInput",
                        staticClass: "site-password-gate__input",
                        attrs: {
                          type: "password",
                          placeholder: "Enter password…",
                          disabled: _vm.passwordState.submitting,
                        },
                        domProps: { value: _vm.passwordState.input },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.passwordState,
                              "input",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "site-password-gate__btn",
                          attrs: {
                            type: "submit",
                            disabled: _vm.passwordState.submitting,
                          },
                        },
                        [
                          _vm.passwordState.submitting
                            ? _c("i", { staticClass: "fa fa-spinner fa-spin" })
                            : _c("span", [_vm._v("Unlock")]),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.passwordState.error
                    ? _c("p", { staticClass: "site-password-gate__error" }, [
                        _c("i", { staticClass: "fa fa-exclamation-circle" }),
                        _vm._v(
                          " " + _vm._s(_vm.passwordState.error) + "\n\t\t\t\t"
                        ),
                      ])
                    : _vm._e(),
                ]),
              ])
            : _vm.loadError
            ? _c("div", { staticClass: "site-404" }, [
                _c("h1", [_vm._v("Something went wrong")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "We couldn't load this page. Please check your connection and try again."
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "site-404__link",
                    attrs: { href: "#" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.fetchPage(_vm.currentPath)
                      },
                    },
                  },
                  [_vm._v("↻ Retry")]
                ),
              ])
            : !_vm.pageData
            ? _c("div", { staticClass: "site-404" }, [
                _c("h1", [_vm._v("Page Not Found")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v("The page "),
                  _c("strong", [_vm._v(_vm._s(_vm.currentPath))]),
                  _vm._v(" does not exist."),
                ]),
                _vm._v(" "),
                _c(
                  "a",
                  { staticClass: "site-404__link", attrs: { href: "/" } },
                  [_vm._v("← Back to Home")]
                ),
              ])
            : [
                _vm.visibleHeaderBlocks.length
                  ? _c(
                      "header",
                      {
                        ref: "siteHeader",
                        staticClass: "site-header",
                        class: {
                          "site-header--sticky":
                            _vm.stickyHeaderMode === "full",
                        },
                      },
                      _vm._l(_vm.visibleHeaderBlocks, function (block) {
                        return _c(
                          "div",
                          {
                            key: "hdr-" + block.id,
                            staticClass: "site-section-outer",
                            style: _vm.sectionOuterStyle(block),
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "site-section-inner",
                                style: _vm.getSectionInnerStyle(block),
                              },
                              [
                                _c("site-block-renderer", {
                                  attrs: {
                                    block: block,
                                    band: _vm.isBand(block),
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.visibleHeaderBlocks.length &&
                _vm.stickyHeaderMode === "condensed" &&
                _vm.headerEl
                  ? _c("condensed-header-bar", {
                      attrs: {
                        "header-blocks": _vm.visibleHeaderBlocks,
                        "floating-blocks": _vm.visibleFloatingHeaderBlocks,
                        "site-settings": _vm.siteSettings,
                        "watch-el": _vm.headerEl,
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "blocks",
                            fn: function ({ blocks }) {
                              return _vm._l(blocks, function (block) {
                                return _c(
                                  "div",
                                  {
                                    key: "flt-" + block.id,
                                    staticClass: "site-section-outer",
                                    style: _vm.sectionOuterStyle(block),
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "site-section-inner",
                                        style: _vm.getSectionInnerStyle(block),
                                      },
                                      [
                                        _c("site-block-renderer", {
                                          attrs: {
                                            block: block,
                                            band: _vm.isBand(block),
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                )
                              })
                            },
                          },
                          {
                            key: "nav",
                            fn: function ({ block }) {
                              return [
                                _c("site-block-renderer", {
                                  attrs: { block: block },
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        656318240
                      ),
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "main",
                  { staticClass: "site-main" },
                  _vm._l(_vm.visibleBlocks, function (block) {
                    return _c(
                      "div",
                      {
                        key: block.id,
                        staticClass: "site-section-outer",
                        style: _vm.sectionOuterStyle(block),
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "site-section-inner",
                            style: _vm.getSectionInnerStyle(block),
                          },
                          [
                            _c("site-block-renderer", {
                              attrs: { block: block, band: _vm.isBand(block) },
                            }),
                          ],
                          1
                        ),
                      ]
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _vm.visibleFooterBlocks.length
                  ? _c(
                      "footer",
                      { staticClass: "site-footer" },
                      _vm._l(_vm.visibleFooterBlocks, function (block) {
                        return _c(
                          "div",
                          {
                            key: "ftr-" + block.id,
                            staticClass: "site-section-outer",
                            style: _vm.sectionOuterStyle(block),
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "site-section-inner",
                                style: _vm.getSectionInnerStyle(block),
                              },
                              [
                                _c("site-block-renderer", {
                                  attrs: {
                                    block: block,
                                    band: _vm.isBand(block),
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e(),
              ],
        ],
        2
      ),
      _vm._v(" "),
      !_vm.isCmsPreview ? _c("accessibility-widget") : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }